var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('calendar.reminderFeed.colorLabel'),"label-class":"text-primary"}},[_c('c-input-color-picker',{attrs:{"translations":{
          modalTitle: _vm.$t('calendar.recordFeed.colorPicker'),
          light: _vm.$t('general:themes.labels.light'),
          dark: _vm.$t('general:themes.labels.dark'),
          cancelBtnLabel: _vm.$t('general:label.cancel'),
          saveBtnLabel: _vm.$t('general:label.saveAndClose')
        },"theme-settings":_vm.themeSettings},model:{value:(_vm.feed.options.color),callback:function ($$v) {_vm.$set(_vm.feed.options, "color", $$v)},expression:"feed.options.color"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }